!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.reactPanZoom = e(require("react")) : t.reactPanZoom = e(t.React);
}(window, function (t) {
  return function (t) {
    var e = {};

    function o(n) {
      if (e[n]) return e[n].exports;
      var r = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }

    return o.m = t, o.c = e, o.d = function (t, e, n) {
      o.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, o.t = function (t, e) {
      if (1 & e && (t = o(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        o.d(n, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return o.d(e, "a", e), e;
    }, o.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, o.p = "", o(o.s = 0);
  }([function (t, e, o) {
    "use strict";

    var n,
        r = this && this.__extends || (n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var o in e) {
        e.hasOwnProperty(o) && (t[o] = e[o]);
      }
    }, function (t, e) {
      function o() {
        this.constructor = t;
      }

      n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o());
    });
    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var a = o(1),
        i = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.getInitialState = function () {
          var t = e.props,
              o = t.pandx,
              n = t.pandy,
              r = t.zoom;
          return {
            comesFromDragging: !1,
            dragData: {
              dx: o,
              dy: n,
              x: 0,
              y: 0
            },
            dragging: !1,
            matrixData: [r, 0, 0, r, o, n],
            mouseDown: !1
          };
        }, e.state = e.getInitialState(), e.onMouseDown = function (t) {
          e.panStart(t.pageX, t.pageY, t);
        }, e.panStart = function (t, o, n) {
          if (e.props.enablePan) {
            var r = e.state,
                a = r.matrixData,
                i = (r.dragData, {
              dx: a[4],
              dy: a[5],
              x: t,
              y: o
            });
            e.setState({
              dragData: i,
              mouseDown: !0
            }), e.panWrapper && (e.panWrapper.style.cursor = "move"), n.stopPropagation(), n.nativeEvent.stopImmediatePropagation(), n.preventDefault();
          }
        }, e.onMouseUp = function (t) {
          e.panEnd(t);
        }, e.panEnd = function (t) {
          e.setState({
            comesFromDragging: e.state.dragging,
            dragging: !1,
            mouseDown: !1
          }), e.panWrapper && (e.panWrapper.style.cursor = ""), e.props.onPan && e.props.onPan(e.state.matrixData[4], e.state.matrixData[5]);
        }, e.onMouseMove = function (t) {
          e.updateMousePosition(t.pageX, t.pageY);
        }, e.updateMousePosition = function (t, o) {
          if (e.state.mouseDown) {
            var n = e.getNewMatrixData(t, o);
            e.setState({
              dragging: !0,
              matrixData: n
            }), e.panContainer && (e.panContainer.style.transform = "matrix(" + e.state.matrixData.toString() + ")");
          }
        }, e.getNewMatrixData = function (t, o) {
          var n = e.state,
              r = n.dragData,
              a = n.matrixData,
              i = r.x - t,
              s = r.y - o;
          return a[4] = r.dx - i, a[5] = r.dy - s, a;
        }, e.reset = function () {
          e.setState({
            matrixData: [1, 0, 0, 1, 0, 0]
          }), e.props.onReset && e.props.onReset(0, 0, 1);
        }, e.onClick = function (t) {
          e.state.comesFromDragging || e.props.onClick && e.props.onClick(t);
        }, e.onTouchStart = function (t) {
          var o = t.touches[0],
              n = o.pageX,
              r = o.pageY;
          e.panStart(n, r, t);
        }, e.onTouchEnd = function (t) {
          e.onMouseUp(t);
        }, e.onTouchMove = function (t) {
          e.updateMousePosition(t.touches[0].pageX, t.touches[0].pageY);
        }, e;
      }

      return r(e, t), e.prototype.componentWillReceiveProps = function (t) {
        if (t.zoom, this.state.matrixData[0] !== t.zoom) {
          var e = this.state.matrixData.slice();
          e[0] = t.zoom || e[0], e[3] = t.zoom || e[3], this.setState({
            matrixData: e
          });
        }
      }, e.prototype.render = function () {
        var t = this;
        return a.createElement("div", {
          className: "pan-container " + (this.props.className || ""),
          onMouseDown: this.onMouseDown,
          onMouseUp: this.onMouseUp,
          onTouchStart: this.onTouchStart,
          onTouchMove: this.onTouchMove,
          onTouchEnd: this.onTouchEnd,
          onMouseMove: this.onMouseMove,
          onClick: this.onClick,
          style: {
            height: this.props.height,
            userSelect: "none",
            width: this.props.width
          },
          ref: function ref(e) {
            return t.panWrapper = e;
          }
        }, a.createElement("div", {
          ref: function ref(e) {
            return e ? t.panContainer = e : null;
          },
          style: {
            transform: "matrix(" + this.state.matrixData.toString() + ")"
          }
        }, this.props.children));
      }, e.defaultProps = {
        enablePan: !0,
        onPan: function onPan() {},
        onReset: function onReset() {},
        pandx: 0,
        pandy: 0,
        zoom: 1
      }, e;
    }(a.PureComponent);

    e.default = i;
  }, function (e, o) {
    e.exports = t;
  }]);
});